export const faqs = [
  {
    question: '基德漫画网的漫画都是免费的吗？',
    answer: '是的！基德漫画网上的所有韩漫完全免费阅读。我们致力于为广大漫画爱好者提供优质的免费漫画资源，无需付费即可畅享精彩内容。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种便捷的漫画阅读方式。您只需在页面上向下滑动即可连续阅读，无需点击翻页按钮。这种阅读方式特别适合在手机上观看，让阅读体验更加流畅自然。',
  },
  {
    question: '网站更新频率如何？',
    answer: '我们每天都会更新新的漫画章节，热门作品的更新频率与官方同步。每周一至周五是主要更新日，周末也会有不定期的惊喜更新。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '基德漫画网全面支持PC端、平板和手机端访问。无论您使用什么设备，都能获得流畅的阅读体验。推荐使用Chrome或Safari浏览器获得最佳效果。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过顶部的搜索框直接搜索漫画名称，也可以通过分类页面按"恋爱"、"奇幻"、"动作"等类型浏览。首页的热门推荐和最新上架区域也能帮您发现好作品。',
  },
  {
    question: '漫画加载慢怎么办？',
    answer: '如果遇到加载速度慢的情况，建议检查网络连接，或尝试切换到WiFi环境。我们也会持续优化服务器性能，确保为读者提供最佳的阅读速度。',
  },
];